import { render, staticRenderFns } from "./solution5.vue?vue&type=template&id=4626b891&scoped=true"
import script from "./solution5.vue?vue&type=script&lang=js"
export * from "./solution5.vue?vue&type=script&lang=js"
import style0 from "./solution5.vue?vue&type=style&index=0&id=4626b891&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626b891",
  null
  
)

export default component.exports